import React from 'react'
import {NavLink} from "react-router-dom"
import './logo192.png';
import ThemeToggle from './ThemeToggle';

const NavBar = () => {
  return (
    <div className= 'nav'>
      <div className='nav-links'>
          <div className="nav-item">
              <NavLink className = "nav-link" to="/" end>
                Home
              </NavLink>
          </div>
        <div className="nav-item">
            <NavLink className = "nav-link" to="/projects">
            Projects
            </NavLink>
        </div>
        <div className="nav-item">
            <NavLink className = "nav-link" to="/contact">
            Contact
            </NavLink>
        </div>
        <div className="nav-item">
            <ThemeToggle />
        </div>
      </div>
    </div>
  )
}

export default NavBar